/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Next_SlideInputs */

const en_next_slide = /** @type {(inputs: Next_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

const fr_next_slide = /** @type {(inputs: Next_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositive suivante`)
};

const de_next_slide = /** @type {(inputs: Next_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Folie`)
};

const it_next_slide = /** @type {(inputs: Next_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositiva successiva`)
};

const ru_next_slide = /** @type {(inputs: Next_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующий слайд`)
};

const es_next_slide = /** @type {(inputs: Next_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente diapositiva`)
};

const zh_cn2_next_slide = /** @type {(inputs: Next_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一张幻灯片`)
};

const ja_next_slide = /** @type {(inputs: Next_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のスライド`)
};

const hi_next_slide = /** @type {(inputs: Next_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगली स्लाइड`)
};

const pt_pt2_next_slide = /** @type {(inputs: Next_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo slide`)
};

/**
* | output |
* | --- |
* | "Next slide" |
*
* @param {Next_SlideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const next_slide = /** @type {((inputs?: Next_SlideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Next_SlideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_next_slide(inputs)
	if (locale === "de") return de_next_slide(inputs)
	if (locale === "it") return it_next_slide(inputs)
	if (locale === "ru") return ru_next_slide(inputs)
	if (locale === "es") return es_next_slide(inputs)
	if (locale === "zh-CN") return zh_cn2_next_slide(inputs)
	if (locale === "ja") return ja_next_slide(inputs)
	if (locale === "hi") return hi_next_slide(inputs)
	if (locale === "pt-PT") return pt_pt2_next_slide(inputs)
	return en_next_slide(inputs)
});